export default __webpack_public_path__ + "static/media/marker-s-p.e0d54d25.png";